import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { getAccessToken } from "../storage/storage";

const useFiles = () => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchFiles = async () => {
        setLoading(true);
        try {
            const token = getAccessToken();
            const response = await axios.get(`${BASE_URL}/api/upload/`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setFiles(response.data || []);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            const errorMessage = error?.response?.data?.message || "Failed to fetch files.";
            Swal.fire({
                icon: "error",
                text: errorMessage,
                customClass: { confirmButton: "custom-red-button" }
            });
        }
    };


    return { loading, files, fetchFiles };
};

export default useFiles;
